<template>
  <div id="app">
    <internet-connection />
    <loader-pg v-if="isLoadding" />
    <register-completation />
    <user-data-edit />
    <menu-top />
    <div class="pg-size">
      <router-view />
    </div>
    <!-- <cart-link /> -->
    <suport-button />
    <!-- <footer-app /> -->
    <cookie-law
      buttonText="Entendi!"
      message="Este site usa cookies para garantir que você obtenha a melhor experiência em nosso site."
    ></cookie-law>
  </div>
</template>

<script>
import Menu from './components/general/Menu'
import LoaderPg from './views/General/Loader'
import CartLink from './components/Cart/Button'
import SuportButton from './components/Support/ButtonWhatsapp'
import UserDataEdit from './components/general/UserModal'
import RegisterCompletation from './components/general/RegisterCompletation'
import InternetConnection from './components/general/InternetConnection'
import Footer from './components/general/Footer'
import CookieLaw from 'vue-cookie-law'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    "internet-connection": InternetConnection,
    "menu-top": Menu,
    "loader-pg": LoaderPg,
    "cart-link": CartLink,
    "suport-button": SuportButton,
    "register-completation": RegisterCompletation,
    "user-data-edit": UserDataEdit,
    "footer-app": Footer,
    "cookie-law": CookieLaw
  },
  computed: {
    ...mapGetters({
      isLoadding: "isLoadding"
    })
  },
  methods: {
    ...mapActions({
      cleanCart: 'cleanCart'
    }),
  }
}
</script>

<style lang="scss">
  @import "./assets/styles/general";
</style>
